import Helpers from '../../common/js/helpers';

export default new class ButtonUp {
  constructor() {
    this.buttonUp = 'button-up';
    this.$buttonUp = $(`.${this.buttonUp}`);

    if (!this.$buttonUp.length) return;

    this.$doc = $(document);
    this.scrollTopTrigger = '_scroll-top-trigger';
    this.show = '_show';

    this.defaultTopOffsetValue = 300;

    this.init();
  }

  init() {
    this.toggleButton();
    this.eventHandlers();
  }

  eventHandlers() {
    this.$doc.on('click', `.${this.buttonUp}`, (e) => {
      const $elemToScroll = $(e.target).closest('.elem-to-scroll-top');

      if (!$elemToScroll.length) return Helpers.scrollPageToTop(e);

      // for modal search, we scroll top modal-search elem, not body
      Helpers.scrollPageToTop(e, $elemToScroll);

      return undefined;
    });
    this.$doc.on('scroll', this.toggleButton.bind(this));
  }

  /**
     * Toggle button to top
     * @return {*}
     */
  toggleButton($scrolledItem = null) {
    const $currentModal = $scrolledItem instanceof jQuery ? $scrolledItem.closest('.modal') : null;
    let showLine;
    let showLineTopOffset;
    let winScrollTop = $(window).scrollTop();

    if ($currentModal) {
      showLine = $currentModal.find(`.${this.scrollTopTrigger}`);
      winScrollTop = $('.modal-search').scrollTop();
    }

    if (showLine) {
      showLineTopOffset = showLine.length ? showLine.offset().top : null;
    } else {
      showLineTopOffset = this.defaultTopOffsetValue;
    }

    if (winScrollTop > showLineTopOffset) {
      return this.$buttonUp.addClass(this.show);
    }

    this.$buttonUp.removeClass(this.show);

    return undefined;
  }
}();
